import React from 'react';
import { FacilityPreviewTemplate } from 'themes/application/facility/pages';
import { observer } from 'mobx-react';
import { FacilityPreviewViewStore } from 'application/facility/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new FacilityPreviewViewStore(rootStore), 'facilityPreviewViewStore')
@observer
class FacilityPreview extends React.Component {
    render() {
        return <FacilityPreviewTemplate {...this.props} />
    }
}

export default FacilityPreview;
